import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import axios from 'utils/axios';
import { creator } from 'uwork-app-core';

/**
 * External Ations
 */
import { actions as orderActions } from './orderSaga';

/**
 * Constants
 */
export const REQUEST = '@app/workers/editordersaga/REQUEST';
export const SUCCESS = '@app/workers/editordersaga/SUCCESS';
export const FAILURE = '@app/workers/editordersaga/FAILURE';
export const CLEAR = '@app/workers/editordersaga/CLEAR';

/**
 * Initial state
 */
const initState = {
    loading: false,
    errorStatus: '',
    success: false
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SUCCESS:
                draft.success = true;
                draft.loading = false;
                break;
            case FAILURE:
                draft.errorStatus = payload;
                draft.loading = false;
                break;
            case REQUEST:
                draft.loading = true;
                draft.errorStatus = '';
                draft.success = false;
                break;
            case CLEAR:
                draft.loading = false;
                draft.errorStatus = '';
                draft.success = false;
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload }) {
        try {
            const response = yield axios.put(`/orders/${payload.id}`, {
                description: payload.description,
                bonus_amount: payload.bonus_amount
            });
            yield put(actions.success());
            yield put(orderActions.success(response.data));
        } catch (e) {
            console.error(e);
            const error =
                (e.response && e.response.data && e.response.data.message) ||
                'Error: Something went wrong please contact support!';
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
